import { Pipe, PipeTransform } from '@angular/core'
/**
 * isString
 */
@Pipe({
  name: 'isString',
})
export class IsStringPipe implements PipeTransform {
  constructor() {}

  transform(value?: unknown): boolean {
    return typeof value === 'string'
  }
}
